import { DadosCadastrais } from '../atoms/forms/DadosCadastrais'
import { DadosPonto } from '../atoms/forms/DadosPonto'
import DSRSection from '../atoms/forms/DSRSection'
import OutrosDados from '../atoms/forms/OutrosDados'

export const tabs = [
    {
        name: 'empresa',
        label: 'Cadastro',
        content: <DadosCadastrais />,
    },
    {
        name: 'ponto',
        label: 'Ponto',
        content: <DadosPonto />,
    },
    {
        name: 'dsr',
        label: 'DSR',
        content: <DSRSection />,
    },
    {
        name: 'outros',
        label: 'Outros',
        content: <OutrosDados />,
    },
]
